import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { keys } from "./constants";

/**
 * Invalidates all cart-related queries, including temporary cart state
 */
export const useInvalidateAllCartQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: keys.all() });
  }, [queryClient]);
};
